<!--
  @component
  Generates an SVG area shape using the `area` function from [d3-shape](https://github.com/d3/d3-shape) and sets the color via an ordinal scale in `zScale`. It assumes your data is in a [D3 stack format](https://github.com/d3/d3-shape#stack).
 -->
<script>
  import { getContext } from "svelte";
  import { area, curveLinear } from "d3-shape";
  import { fade } from "svelte/transition";
  import { urbanColors } from "@urbaninstitute/dataviz-components/utils";

  const { data, xGet, yScale, zGet, height, custom } = getContext("LayerCake");

  let { curve = curveLinear, opacity = 1, highlight } = $props();

  let areaGen = $derived(
    area()
      .x((d) => $xGet(d))
      .y0((d) => $yScale(d[0]))
      .y1((d) => $yScale(d[1]))
      .curve(curve)
  );

  const HIGHLIGHT_DIM = 0.5;

  function getOpacity(key) {
    if (highlight) {
      if (highlight === key) {
        return 1;
      }
      return HIGHLIGHT_DIM;
    }
    return opacity;
  }
</script>

{#if $height > 0}
  <g class="area-group">
    {#each $data as d (d.key)}
      <path
        class="path-area"
        d={areaGen(d)}
        fill={$zGet(d)}
        opacity={getOpacity(d.key)}
        stroke={highlight && getOpacity(d.key) == 1 ? "white" : "none"}
        stroke-width={highlight && getOpacity(d.key) == 1 ? 3 : 0}
        transition:fade={{ duration: 200, delay: 0 }}
      ></path>
    {/each}
  </g>
{/if}

<style>
  path {
    transition:
      d 200ms ease,
      opacity 200ms ease;
    cursor: pointer;
  }
</style>
